<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">매출현황</span>
            <span class="txt">
                핏투데이케어 프로그램 이용 시 발생하는 매출 내역에 대한 전반적인 내용을 확인할 수 있습니다.
            </span>
        </div>

        <div class="sales-info-table">
            <div class="top-content">
                <div class="item-box">
                    <span class="tit">프로그램 매출</span>
                    <span class="count">
                        <span class="num blue">{{ programType.totalPrice | numberFormatFilter }}원</span>
                        <span class="txt">({{ programType.totalCnt | numberFormatFilter }}건)</span>
                    </span>
                </div>
                <div class="item-box plus"></div>
                <div class="item-box">
                    <span class="tit">부가서비스 매출</span>
                    <span class="count">
                        <span class="num blue">{{ vatType.totalPrice | numberFormatFilter }}원</span>
                        <span class="txt">({{ vatType.totalCnt | numberFormatFilter }}건)</span>
                    </span>
                </div>
                <div class="item-box minus"></div>
                <div class="item-box">
                    <span class="tit">총 환불</span>
                    <span class="count">
                        <span class="num red">{{ regType.refundPrice | numberFormatFilter }}원</span>
                        <span class="txt">({{ regType.refundCnt | numberFormatFilter }}건)</span>
                    </span>
                </div>
                <div class="item-box equal"></div>
                <div class="item-box">
                    <span class="tit">합계</span>
                    <span class="count">
                        <span class="num green">{{ totalPrice | numberFormatFilter }}원</span>
                    </span>
                </div>
            </div>
        </div>

        <div class="sales-table-info">
            <div class="item-box">
                <div class="top-area">
                    <span class="tit">결제수단별 매출</span>
                </div>
                <table>
                    <colgroup>
                        <col style="width: 120px" />
                        <col style="width: 80px" />
                        <col style="width: 135px" />
                    </colgroup>
                    <tbody>
                        <tr>
                            <th>카드</th>
                            <td>{{ payType.cardCnt | numberFormatFilter }}건</td>
                            <td class="right">{{ payType.cardPrice | numberFormatFilter }}원</td>
                        </tr>
                        <tr>
                            <th>현금</th>
                            <td>{{ payType.cashCnt | numberFormatFilter }}건</td>
                            <td class="right">{{ payType.cashPrice | numberFormatFilter }}원</td>
                        </tr>
                        <tr>
                            <th>계좌</th>
                            <td>{{ payType.bankCnt | numberFormatFilter }}건</td>
                            <td class="right">{{ payType.bankPrice | numberFormatFilter }}원</td>
                        </tr>
                        <tr>
                            <th>기타</th>
                            <td>{{ payType.etcCnt | numberFormatFilter }}건</td>
                            <td class="right">{{ payType.etcPrice | numberFormatFilter }}원</td>
                        </tr>
                        <tr class="all">
                            <th>합계</th>
                            <td>{{ payType.totalCnt | numberFormatFilter }}건</td>
                            <td class="right">{{ payType.totalPrice | numberFormatFilter }}원</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="item-box">
                <div class="top-area">
                    <span class="tit">프로그램별 매출</span>
                </div>
                <table>
                    <colgroup>
                        <col style="width: 120px" />
                        <col style="width: 80px" />
                        <col style="width: 135px" />
                    </colgroup>
                    <tbody>
                        <tr>
                            <th>베이직</th>
                            <td>{{ programType.basicCnt | numberFormatFilter }}건</td>
                            <td class="right">{{ programType.basicPrice | numberFormatFilter }}원</td>
                        </tr>
                        <tr>
                            <th>스탠다드</th>
                            <td>{{ programType.businessCnt | numberFormatFilter }}건</td>
                            <td class="right">{{ programType.businessPrice | numberFormatFilter }}원</td>
                        </tr>
                        <tr>
                            <th>프리미엄</th>
                            <td>{{ programType.specialCnt | numberFormatFilter }}건</td>
                            <td class="right">{{ programType.specialPrice | numberFormatFilter }}원</td>
                        </tr>
                        <tr class="all">
                            <th>합계</th>
                            <td>{{ programType.totalCnt | numberFormatFilter }}건</td>
                            <td class="right">{{ programType.totalPrice | numberFormatFilter }}원</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="item-box">
                <div class="top-area">
                    <span class="tit">부가서비스 매출</span>
                </div>
                <table>
                    <colgroup>
                        <col style="width: 120px" />
                        <col style="width: 80px" />
                        <col style="width: 135px" />
                    </colgroup>
                    <tbody>
                        <tr>
                            <th>문자서비스</th>
                            <td>{{ vatType.messageCnt | numberFormatFilter }}건</td>
                            <td class="right">{{ vatType.messagePrice | numberFormatFilter }}원</td>
                        </tr>
                        <tr>
                            <th>부가서비스</th>
                            <td>{{ vatType.vatCnt | numberFormatFilter }}건</td>
                            <td class="right">{{ vatType.vatPrice | numberFormatFilter }}원</td>
                        </tr>
                        <tr class="all">
                            <th>합계</th>
                            <td>{{ vatType.totalCnt | numberFormatFilter }}건</td>
                            <td class="right">{{ vatType.totalPrice | numberFormatFilter }}원</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="item-box">
                <div class="top-area">
                    <span class="tit">등록구분별 매출</span>
                </div>
                <table>
                    <colgroup>
                        <col style="width: 120px" />
                        <col style="width: 80px" />
                        <col style="width: 135px" />
                    </colgroup>
                    <tbody>
                        <tr>
                            <th>신규</th>
                            <td>{{ regType.newCnt | numberFormatFilter }}건</td>
                            <td class="right">{{ regType.newPrice | numberFormatFilter }}원</td>
                        </tr>
                        <tr>
                            <th>재등록</th>
                            <td>
                                <span class="blue">{{ regType.resignCnt | numberFormatFilter }}건</span>
                            </td>
                            <td class="right">{{ regType.resignPrice | numberFormatFilter }}원</td>
                        </tr>
                        <tr>
                            <th>환불</th>
                            <td>
                                <span class="blue">{{ regType.refundCnt | numberFormatFilter }}건</span>
                            </td>
                            <td class="right">{{ regType.refundPrice | numberFormatFilter }}원</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="com-search-content">
            <div class="line">
                <div class="com-calendar-wrap">
                    <single-calendar :start-date="startDate" @update="startDateUpdate"></single-calendar>
                    <div class="com-dash"><span class="dash">~</span></div>
                    <single-calendar :end-date="endDate" @update="endDateUpdate"></single-calendar>
                </div>
                <select-form
                    :select-data="['선택', ...periodTypeList]"
                    :select-value="['', ...periodTypeValueList]"
                    :selected-value="searchPeriod"
                    @update:set="(val) => (searchPeriod = val)"
                ></select-form>
                <div class="com-search-input">
                    <input v-model="searchStr" placeholder="센터명 입력" type="text" v-on:keyup.enter="onEventSearch" />
                    <button class="search-btn" @click="onEventSearch">검색</button>
                </div>
            </div>
            <div class="line">
                <select-form
                    :select-data="['계약유형', '전체', '월 결제', '선 결제']"
                    :select-value="['', '', 'M', 'P']"
                    @update:set="(val) => (contractType = val)"
                ></select-form>
                <!--
                * 2021.03.14, notbadlife@eb, 고객 요청으로 해당 검색 부분 제거
                <select-form :select-data='["가입항목","전체","프로그램","문자서비스","부가서비스"]'
                             :select-value="['','','P','M','B']"
                             @update:set="val => productType = val"></select-form>
                -->
                <select-form
                    :select-data="['등록구분', '전체', '신규', '재등록', '환불']"
                    :select-value="['', '', 'N', 'R', 'C']"
                    @update:set="(val) => (contractStatusDetail = val)"
                ></select-form>
                <select-form
                    :select-data="['결제수단', '전체', '카드', '현금', '계좌이체', '기타']"
                    :select-value="['', '', 'C', 'L', 'B', 'E']"
                    @update:set="(val) => (payTypes = val)"
                ></select-form>
                <select-form
                    :select-data="['매출직원', '전체', ...ftStaffList]"
                    :select-value="['', '', ...fatStaffValList]"
                    @update:set="(val) => (saleStaffId = val)"
                ></select-form>
                <button class="com-search-reset" @click="resetSearchContent"></button>
            </div>
        </div>

        <div class="com-table-content">
            <table class="com-table">
                <colgroup>
                    <col style="width: 125px" />
                    <col style="width: 200px" />
                    <col style="width: 110px" />
                    <col style="width: 110px" />
                    <col style="width: 360px" />
                    <col style="width: 85px" />
                    <col style="width: 125px" />
                    <col style="width: 140px" />
                    <col style="width: 180px" />
                    <col style="width: 100px" />
                </colgroup>
                <thead>
                    <tr>
                        <th>
                            <button>결제일</button>
                        </th>
                        <th>
                            <button>센터명</button>
                        </th>
                        <th>
                            <button>계약유형</button>
                        </th>
                        <th>
                            <button>가입항목</button>
                        </th>
                        <th>
                            <button>서비스명</button>
                        </th>
                        <th>
                            <button>등록구분</button>
                        </th>
                        <th>
                            <button>계약금액</button>
                        </th>
                        <th>
                            <button>총 결제금액</button>
                        </th>
                        <th>
                            <button>결제금액</button>
                        </th>
                        <th>
                            <button>매출직원</button>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <template v-for="(list, listIndex) in contractList">
                        <tr v-for="(c, index) in list">
                            <td v-if="index === 0" :rowspan="list.length > 1 && index === 0 ? list.length : ''">
                                {{ c.fc_bill_dt | timestampFilter }}
                            </td>
                            <td v-if="index === 0" :rowspan="list.length > 1 && index === 0 ? list.length : ''">
                                {{ c.fc_center_nm }}
                            </td>
                            <td>{{ c.fc_contract_type_cd ? cvtContract(c.fc_contract_type_cd) : '-' }}</td>
                            <td>{{ convertProd(c.fc_prod_type_cd) }}</td>
                            <td>
                                {{ c.fc_prod_nm }}
                                <span :title="c.fc_prod_nm" class="com-btn blue">메모</span>
                            </td>
                            <td>{{ convertStatus(c.fc_contract_status_detl_cd) }}</td>
                            <td>{{ c.fcp_ft_prod_buy_price | numberFormatFilter }}</td>
                            <td v-if="index === 0" :rowspan="list.length > 1 && index === 0 ? list.length : ''">
                                {{ c.fc_contract_total_price | numberFormatFilter }}
                            </td>
                            <td v-if="index === 0" :rowspan="list.length > 1 && index === 0 ? list.length : ''">
                                {{ convertPay(c.fc_pay_type_cd) }} {{ c.fc_bill_price | numberFormatFilter }}
                                <span class="com-btn deep-black">현</span>
                                <br />
                                <!--현금영수증관련 -->
                            </td>
                            <td>{{ c.fc_sale_staff_nm }}</td>
                        </tr>
                    </template>
                    <tr v-if="contractList.length === 0">
                        <td colspan="100">등록된 내용이 없습니다.</td>
                    </tr>
                </tbody>
            </table>
            <div class="sort-bottom-area">
                <button class="com-btn excel">엑셀 다운로드</button>
                <select-form
                    :select-data="[...sortTypeList]"
                    :select-value="[...sortTypeValueList]"
                    class="float-right"
                    @update:set="changeLimit"
                ></select-form>
            </div>
            <b-pagination
                v-model="pagingInfo.page"
                :per-page="pagingInfo.limit"
                :total-rows="pagingInfo.totalItems"
                align="center"
                aria-controls="my-table"
                first-class="first"
                last-class="last"
                next-class="next"
                prev-class="prev"
                @change="handlerPagenation($event)"
            ></b-pagination>
        </div>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import moment from 'moment';
import EventBus from '../../../assets/js/eventBus';
import { pagingInfo } from '@/assets/js/common';
export default {
    name: 'SalesState',
    props: {},
    computed: {
        totalPrice() {
            return (
                parseInt(this.programType.totalPrice) +
                parseInt(this.vatType.totalPrice) -
                parseInt(this.regType.refundPrice)
            );
        },
    },
    watch: {
        searchPeriod: function (newValue) {
            // 검색 기간 설정 변수
            this.searchPeriod = newValue;

            if (newValue === 'today') {
                // 오늘
                this.startDate = moment().format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === 'yesterday') {
                // 어제
                this.startDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
                this.endDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
            } else if (newValue === 'thisMonth') {
                // 이번 달
                this.startDate = moment().startOf('month').format('YYYY-MM-DD');
                this.endDate = moment().endOf('month').format('YYYY-MM-DD');
            } else if (newValue === 'prevMonth') {
                // 지난 달
                this.startDate = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
                this.endDate = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
            } else if (newValue === '3M') {
                // 3개월
                this.startDate = moment().subtract(3, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === '6M') {
                // 6개월
                this.startDate = moment().subtract(6, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === '12M') {
                // 12개월
                this.startDate = moment().subtract(12, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === '') {
                this.initStartDate();
                this.initEndDate();
            }
            this.onContractDetail();
        },
        payTypes: function (newValue) {
            this.onContractDetail();
        },
        contractStatusDetail: function (newValue) {
            this.onContractDetail();
        },
        productType: function (newValue) {
            this.onContractDetail();
        },
        contractType: function (newValue) {
            this.onContractDetail();
        },
        saleStaffId: function (newValu) {
            //스태프 선택시 재조회
            this.onContractDetail();
        },
    },
    data() {
        return {
            contractList: [],
            pagingInfo: { ...pagingInfo },
            sortTypeList: [...this.$sortType],
            sortTypeValueList: [...this.$sortTypeValue],
            periodTypeList: [...this.$periodTypeList],
            periodTypeValueList: [...this.$periodTypeValueList],

            searchStr: '', // 이름, 연락처 검색 파라미터
            searchPeriod: '', // 검색 기간 설정
            startDate: moment().startOf('month').format('YYYY-MM-DD'),
            endDate: moment().format('YYYY-MM-DD'),

            //결제수단별 매출
            payType: {
                cardPrice: 0,
                cardCnt: 0,
                cashPrice: '',
                cashCnt: 0,
                bankPrice: 0,
                bankCnt: 0,
                etcPrice: 0,
                etcCnt: 0,
                totalCnt: 0,
                totalPrice: 0,
            },
            programType: {
                basicCnt: 0,
                basicPrice: 0,
                businessCnt: 0,
                businessPrice: 0,
                mobileCnt: 0,
                mobilePrice: 0,
                specialCnt: 0,
                specialPrice: 0,
                totalCnt: 0,
                totalPrice: 0,
            },
            vatType: {
                messagePrice: 0,
                messageCnt: 0,
                vatPrice: 0,
                vatCnt: 0,
                totalCnt: 0,
                totalPrice: 0,
            },
            //등록구분별
            regType: {
                newPrice: 0,
                newCnt: 0,
                resignPrice: 0,
                resignCnt: 0,
                refundPrice: 0,
                refundCnt: 0,
            },

            contractType: '',
            productType: '', //가입항목
            contractStatusDetail: '', //등록구분
            payTypes: '', //결제수단

            ftStaffList: [],
            fatStaffValList: [],
            saleStaffId: '',
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            try {
                await this.onContractDetail(); // 조회
                await this.onPayTypeSale(); // 결제타입
                await this.onProgramSale(); // 프로그램별
                await this.onVatSale(); // 프로그램별
                await this.onRegSale(); // 등록구분별
                await this.onFecthStaffList(); // Ft 직원조회
            } catch (error) {
                console.log(error);
            }
        },
        // 계약내용 페이지 조회
        async onContractDetail() {
            try {
                const { data } = await this.getContractDeatil();

                this.setPageParams(data);

                let obj = {};
                for (let d of data.items) {
                    const key = d.fc_bill_dt + d.fc_center_id;

                    if (obj[key] === undefined) {
                        obj[key] = [];
                    }

                    obj[key].push(d);
                }

                let keys = Object.keys(obj);

                this.contractList = [];
                for (let k of keys) {
                    this.contractList.push(obj[k]);
                }
            } catch (error) {
                console.log(error);
            }
        },
        getContractDeatil() {
            return api.get(`/admin/api/ft/sales/term/contract`, {
                params: {
                    ...this.pagingInfo,
                    startDate: moment(this.startDate).format('YYYYMMDD'),
                    endDate: moment(this.endDate).format('YYYYMMDD'),
                    contractType: this.contractType, //계약유형
                    productType: this.productType, //가입항목
                    contractStatusDetail: this.contractStatusDetail, //등록구분
                    payType: this.payTypes, //결제수단
                    saleStaffId: this.saleStaffId, //매출직원
                    centerName: this.searchStr, // 센터명 검색어
                },
            });
        },
        // 한 페이지에 표시되는 줄 수 변경
        changeLimit(val) {
            this.pagingInfo.limit = val;
            this.onContractDetail();
        },

        // 페이징 이벤트
        handlerPagenation(event) {
            this.pagingInfo.page = event;
            this.onContractDetail();
        },
        // 페이징 Param 설정
        setPageParams(data) {
            this.pagingInfo.totalPages = data.meta.totalPages;
            this.pagingInfo.page = data.meta.currentPage;
            this.pagingInfo.totalItems = data.meta.totalItems;
            this.pagingInfo.itemCount = data.meta.itemCount;
        },
        // 검색 시작일 변경 event
        startDateUpdate(val) {
            this.startDate = val;
            this.onContractDetail();
        },

        // 검색 종료일 변경 event
        endDateUpdate(val) {
            this.endDate = val;
            this.onContractDetail();
        },
        //결제수단별 매출
        async onPayTypeSale() {
            try {
                const { data } = await this.getPayTypeSale();
                data.forEach((g) => {
                    if (g.fcb_pay_type_cd == 'C') {
                        this.payType.cardPrice = g.fcb_bill_price;
                        this.payType.cardCnt = g.fcb_pay_type_cnt;
                    } else if (g.fcb_pay_type_cd == 'L') {
                        this.payType.cashPrice = g.fcb_bill_price;
                        this.payType.cashCnt = g.fcb_pay_type_cnt;
                    } else if (g.fcb_pay_type_cd == 'B') {
                        this.payType.bankPrice = g.fcb_bill_price;
                        this.payType.bankCnt = g.fcb_pay_type_cnt;
                    } else if (g.fcb_pay_type_cd == 'E') {
                        this.payType.etcPrice = g.fcb_bill_price;
                        this.payType.etcCnt = g.fcb_pay_type_cnt;
                    }
                    this.payType.totalCnt += parseInt(g.fcb_pay_type_cnt);
                    this.payType.totalPrice += parseInt(g.fcb_bill_price);
                });
            } catch (error) {
                console.log(error);
            }
        },
        getPayTypeSale() {
            return api.get(`/admin/api/ft/sales/term/pay-type`, {
                params: {
                    startDate: moment(this.startDate).format('YYYYMMDD'),
                    endDate: moment(this.endDate).format('YYYYMMDD'),
                },
            });
        },
        //프로그램별 매출
        async onProgramSale() {
            try {
                const { data } = await this.getProgramSale();
                data.forEach((g) => {
                    if (g.fcb_pg_type_cd == 'B') {
                        this.programType.basicCnt = g.fcb_cnt;
                        this.programType.basicPrice = g.fcb_bill_price;
                        this.programType.totalCnt += parseInt(g.fcb_cnt);
                        this.programType.totalPrice += parseInt(g.fcb_bill_price);
                    } else if (g.fcb_pg_type_cd == 'N') {
                        this.programType.businessCnt = g.fcb_cnt;
                        this.programType.businessPrice = g.fcb_bill_price;
                        this.programType.totalCnt += parseInt(g.fcb_cnt);
                        this.programType.totalPrice += parseInt(g.fcb_bill_price);
                    } else if (g.fcb_pg_type_cd == 'S') {
                        this.programType.specialCnt = g.fcb_cnt;
                        this.programType.specialPrice = g.fcb_bill_price;
                        this.programType.totalCnt += parseInt(g.fcb_cnt);
                        this.programType.totalPrice += parseInt(g.fcb_bill_price);
                    }
                });
            } catch (error) {
                console.log(error);
            }
        },
        getProgramSale() {
            return api.get(`/admin/api/ft/sales/term/program-type`, {
                params: {
                    startDate: moment(this.startDate).format('YYYYMMDD'),
                    endDate: moment(this.endDate).format('YYYYMMDD'),
                },
            });
        },
        //부가서비스 매출
        async onVatSale() {
            try {
                const { data } = await this.getVatSale();
                data.forEach((g) => {
                    if (g.fcb_prod_type_cd == 'B') {
                        this.vatType.messagePrice = g.fcb_bill_price;
                        this.vatType.messageCnt = g.fcb_cnt;
                        this.vatType.totalCnt += parseInt(g.fcb_cnt);
                        this.vatType.totalPrice += parseInt(g.fcb_bill_price);
                    } else if (g.fcb_prod_type_cd == 'M') {
                        this.vatType.vatPrice = g.fcb_bill_price;
                        this.vatType.vatCnt = g.fcb_cnt;
                        this.vatType.totalCnt += parseInt(g.fcb_cnt);
                        this.vatType.totalPrice += parseInt(g.fcb_bill_price);
                    }
                });
            } catch (error) {
                console.log(error);
            }
        },
        getVatSale() {
            return api.get(`/admin/api/ft/sales/term/service-type`, {
                params: {
                    startDate: moment(this.startDate).format('YYYYMMDD'),
                    endDate: moment(this.endDate).format('YYYYMMDD'),
                },
            });
        },
        //등록구분별 매출
        async onRegSale() {
            try {
                const { data } = await this.getRegSale();
                data.forEach((g) => {
                    if (g.fcb_contract_status_detl_cd == 'N') {
                        this.regType.newPrice = g.fcb_bill_price;
                        this.regType.newCnt = g.fcb_cnt;
                    } else if (g.fcb_contract_status_detl_cd == 'R') {
                        this.regType.resignPrice = g.fcb_bill_price;
                        this.regType.resignCnt = g.fcb_cnt;
                    } else if (g.fcb_contract_status_detl_cd == 'C') {
                        this.regType.refundPrice = g.fcb_bill_price;
                        this.regType.refundCnt = g.fcb_cnt;
                    }
                });
            } catch (error) {
                console.log(error);
            }
        },
        getRegSale() {
            return api.get(`/admin/api/ft/sales/term/status-type`, {
                params: {
                    startDate: moment(this.startDate).format('YYYYMMDD'),
                    endDate: moment(this.endDate).format('YYYYMMDD'),
                },
            });
        },
        // 검색 시작일 초기화
        initStartDate() {
            const startDate = moment().startOf('month').format('YYYY-MM-DD');
            this.startDate = startDate;
        },

        // 검색 종료일 초기화
        initEndDate() {
            const endDate = moment().format('YYYY-MM-DD');
            this.endDate = endDate;
        },
        // 검색 조건 초기화
        resetSearchContent() {
            (this.contractType = ''),
                (this.productType = ''), //가입항목
                (this.contractStatusDetail = ''), //등록구분
                (this.payTypes = ''), //결제수단
                (this.searchType = '');
            (this.saleStaffId = ''), //판매스태프
                this.onContractDetail();
            EventBus.$emit('event:initList', 'init');
        },
        cvtContract(val) {
            if (val == 'P') {
                return '선결제';
            } else if (val == 'M') {
                return '월결제';
            }
        },
        convertProd(val) {
            if (val == 'P') {
                return '프로그램';
            } else if (val == 'M') {
                return '문자서비스';
            } else if (val == 'B') {
                return '부가서비스';
            }
        },
        convertStatus(val) {
            if (val == 'N') {
                return '신규';
            } else if (val == 'R') {
                return '재등록';
            } else if (val == 'C') {
                return '환불';
            }
        },
        convertPay(val) {
            if (val == 'C') {
                return '카드';
            } else if (val == 'L') {
                return '현금';
            } else if (val == 'B') {
                return '계좌';
            } else if (val == 'E') {
                return '기타';
            }
        },
        //ft 직원 조회
        async onFecthStaffList() {
            try {
                const { data } = await this.getFetchStaffList();
                data.items.forEach((g) => {
                    this.ftStaffList.push(g.s_namee);
                    this.fatStaffValList.push(g.s_id);
                });
            } catch (error) {
                console.log(error);
            }
        },
        getFetchStaffList() {
            return api.get(`/admin/api/ft/staff`, {
                params: {
                    page: 1,
                    limit: 10, //10명으로 설정(변경가능)
                },
            });
        },
        //검색어 입력
        onEventSearch(e) {
            if (this.searchStr.length > 0 && this.searchStr.length < 2) {
                return;
            }
            this.onContractDetail();
        },
    },
};
</script>
<style lang="scss"></style>
